// @flow
import React, { PureComponent } from 'react'
import Utils from 'live/lib/utils'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import ReactDOM from 'react-dom'
import Modal from 'live/components/ui/Modal'
import GeneralComment from './generalComment'

class GeneralCommentService {

    rendered = false
    root: ?HTMLElement

    constructor (url: string) {
        this.root = document.createElement('div')

        document.body.appendChild(this.root)

        window.Live.openGeneralComment = this.showGeneralComment
    }

    showGeneralComment = generalComment => {
        ReactDOM.render(<GeneralCommentModal onHide={this.onHide} generalComment={generalComment} />, this.root)
    }

    onHide = a => {
        this.rendered = false
        ReactDOM.unmountComponentAtNode(this.root)
    }

}

const generalCommentService = new GeneralCommentService()

export default generalCommentService

class GeneralCommentModal extends PureComponent {

    state = {
        edit: false
    }

    submitFn = console.warn.bind(null, 'No submit function lifted.')

    onEdit = (event, form) => {
        this.setState({
            edit: true,
            FormComponent: form.component,
            editingEvent: { ...this.props.generalComment }
        })
    }

    renderEdit = () => {
        const { FormComponent, editingEvent } = this.state

        return (
            <FormComponent
                onHide={generalComment => {
                    this.setState({
                        generalComment: generalComment && generalComment.uid ? generalComment : null,
                        edit: false
                    })
                }}
                liftSubmitFn={fn => (this.submitFn = fn)}
                event={editingEvent}
                showActions={true}
            />
        )
    }

    renderView = () => {
        return (
            <GeneralComment
                onDelete={this.props.onHide}
                expanded={true}
                event={this.state.generalComment || this.props.generalComment}
                onEdit={this.onEdit}
                onHide={this.props.onHide}
            />
        )
    }

    render () {
        const { edit } = this.state
        const { onHide } = this.props

        return (
            <Modal backdrop="static" keyboard={false} onHide={onHide} show={true}>
                <React.Fragment>{edit ? this.renderEdit() : this.renderView()}</React.Fragment>
            </Modal>
        )
    }

}
